import React from 'react';
import { Link } from 'carbon-components-react';

const RegistrationFooter: React.FC = () => (
  <p>
    Need help?<Link href="#"> Contact us</Link>
  </p>
);

export default React.memo(RegistrationFooter);
